module.exports = __webpack_public_path__ + "static/media/33.233584f4.JPG";